module.exports = __webpack_public_path__ + "static/media/molecule.9496ba37.svg";